import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { RequireAuth } from "./RequireAuth";

export function AppShell() {

    return (
        <RequireAuth>
            <div className="min-h-screen flex flex-row">
                <Sidebar />
                <div className="flex-1 flex flex-col">
                    <Header />
                    <main className="flex-1 overflow-y-auto bg-background">
                        <Outlet />
                    </main>
                </div>
            </div>
        </RequireAuth>
    );
}
